<div class="modal__content">
  <ng-container *ngIf="!loading">
    <wfm-select-panel placeholder="Select an Option"
                      [search]="true"
                      [placeholder] = "'taggedExams.searchPlaceholder'| translate"
                      [itemTemplate]="radName"
                      [items]="radList"
                      [(value)]="selected">
    </wfm-select-panel>
  </ng-container>
  <wfm-spinner *ngIf="loading" size="40"></wfm-spinner>
</div>

<div class="modal__footer u-mt- u-pt--">
  <span *ngIf="isRadListPrivileged">{{ 'assignments.confidentialPrivilegedMsg' | translate}}</span>
  <span *ngIf="isNawExam">{{ 'naw.reassign.warningDialog.description' | translate}}</span>
  <span>
    <button id="assignExamDialogSaveButton"
            (click)="assign(); $event.stopPropagation()"
            tabindex="1"
            [ngClass]="{'disabled' : !(currentUser || radList || loading) && selected}"
            [innerHTML]="'label.assign' | translate">
    </button>
  </span>
</div>

<ng-template #radName let-i="index" let-item="item">
  {{ item.name }}
</ng-template>
